import { Link } from "react-router-dom";
import BookEditorModeTabs from "./BookEditorModeTabs";
import BookEditorToolRail from "./BookEditorToolRail";
import BookEditorLeftPanel from "./BookEditorLeftPanel";
import BookEditorInspector from "./BookEditorInspector";
import BookEditorStatusBar from "./BookEditorStatusBar";
import BookEditorAI from "./BookEditorAI";
import { useBookEditor } from "./BookEditorProvider";
import { bookLabHomeUrl } from "../../../lib/bookLabRoutes";
import "./bookEditorShell.css";

export default function BookEditorShell({ children }) {
  const { book, mode, saveStatus, saveError, loadError, loading } = useBookEditor();

  return (
    <div
      className={`book-editor-shell book-editor-shell--${mode}`}
      data-testid="book-editor-shell"
      data-mode={mode}
    >
      <header className="book-editor-menu">
        <Link to={bookLabHomeUrl()} className="book-editor-back" data-testid="book-editor-back">
          ← Book Lab
        </Link>
        <nav className="book-editor-menu-nav" aria-label="Application menu">
          {["File", "Edit", "Layout", "Type", "Object", "Table", "View", "AI", "Export", "Help"].map((label) => (
            <button key={label} type="button" data-testid={`menu-${label.toLowerCase()}`}>
              {label}
            </button>
          ))}
        </nav>
        <div className="book-editor-menu__title">
          <span>Book Editor</span>
          <strong>{book?.title || (loading ? "Loading book…" : "Untitled Book")}</strong>
        </div>
      </header>

      <section className="book-editor-modebar">
        <div className="book-editor-modebar__book">
          <strong>{book?.title || "Untitled Book"}</strong>
          <span>{book?.subtitle || book?.author || ""}</span>
        </div>

        <BookEditorModeTabs />

        <div
          className={`save-state save-state--${saveStatus}`}
          data-testid="book-editor-save-state"
        >
          {saveStatus === "saving" && "Saving…"}
          {saveStatus === "saved" && "Saved"}
          {(saveStatus === "idle" || !saveStatus) && "All changes saved"}
          {saveStatus === "failed" && <span>{saveError || "Save failed"}</span>}
        </div>
      </section>

      {loadError && (
        <div className="book-editor-flash err" data-testid="book-editor-load-error">
          {loadError}
        </div>
      )}

      <main className="book-editor-main">
        <BookEditorToolRail />
        <BookEditorLeftPanel />
        <section className="book-editor-stage" data-testid="book-editor-stage">
          {children}
          <BookEditorAI />
        </section>
        <BookEditorInspector />
      </main>

      <BookEditorStatusBar />
    </div>
  );
}
